<template>
  <tela-component :title="isMobile() ? $route.name : 'Configurações'">
    <v-list v-if="$route.matched.length < 2">
      <v-subheader>Opções disponíveis</v-subheader>
      <v-list-item
        v-for="(opcao, i) in opcoes_config"
        :key="i"
        :to="opcao.rota"
      >
        <v-list-item-avatar>
          <v-icon>{{ opcao.icone }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ opcao.descricao }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon>mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <router-view v-else></router-view>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
export default {
  components: { TelaComponent },
  data: () => ({    
    opcoes_config: [
      {
        descricao: "Horários",
        icone: "mdi-timer-cog-outline",
        rota: "configuracoes/horarios",
      },
    ],
  }),
  methods: {
    isMobile(){
        return this.$mq == 'sm'
    }
  }
  
};
</script>

<style>
</style>